import authAxios from '../authorization/axios';
import constants from '../constants';

export const getOrderService = async (orderId: number) => {
  const main = `${constants.api.getOrder}/${orderId}`;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const getOrderPaymentsService = async (orderId: any) => {
  const main = constants.api.getOrderPayments.replace('{orderId}', orderId);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const deletePaymentService = async (orderPaymentId: string) => {
  const main = constants.api.deletePayment.replace('{paymentId}', orderPaymentId);

  // TODO: typing the response.
  const response = await authAxios.delete(main);

  return response;
};

export const downloadCreditNoteService = async (creditNoteId: string) => {
  const main = constants.api.downloadCreditNote.replace('{creditNoteId}', creditNoteId);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const dowloadPaymentInvoice = async (paymentId: string) => {
  const main = constants.api.dowloadPaymentInvoice.replace('{paymentId}', paymentId);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};